import { Injectable, TemplateRef, inject } from '@angular/core';
import {
  NzNotificationService,
  NzNotificationDataOptions,
  NzNotificationRef,
  NzNotificationContentType,
} from 'ng-zorro-antd/notification';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly nzNotification = inject(NzNotificationService);

  private create(
    type: 'success' | 'error' | 'info' | 'warning',
    title: string | TemplateRef<void>,
    content?: NzNotificationContentType,
    options?: NzNotificationDataOptions
  ) {
    content = content || '';
    const defaultOptions = {
      nzClass: `notification-${type}`,
    };

    return this.nzNotification.create(type, title, content, {
      ...defaultOptions,
      ...options,
    });
  }

  public info(
    title: string | TemplateRef<void>,
    content?: NzNotificationContentType,
    options?: NzNotificationDataOptions
  ): NzNotificationRef {
    return this.create('info', title, content, options);
  }

  public error(
    title: string | TemplateRef<void>,
    content: NzNotificationContentType,
    options?: NzNotificationDataOptions
  ): NzNotificationRef {
    return this.create('error', title, content, options);
  }

  public warning(
    title: string | TemplateRef<void>,
    content?: NzNotificationContentType,
    options?: NzNotificationDataOptions
  ): NzNotificationRef {
    return this.create('warning', title, content, options);
  }

  public success(
    title: string | TemplateRef<void>,
    content?: NzNotificationContentType,
    options?: NzNotificationDataOptions
  ): NzNotificationRef {
    return this.create('success', title, content, options);
  }
}
